(() => {



  let topButton = document.getElementById('js-Item-Top_Button');

  window.addEventListener('scroll', () => {
    if(window.pageYOffset > 100) {
      topButton.classList.remove('sw-Top-Hidden');
    } else {
      topButton.classList.add('sw-Top-Hidden');
    }
  }, false);



  let accordionButton     = document.getElementsByClassName('js-Item-Accordion_Button');
  let accordionButtonIcon = document.getElementsByClassName('js-Item-Accordion_Button_Icon');
  let accordionBox        = document.getElementsByClassName('js-Item-Accordion_Box');

  for(let i = 0; i < accordionButton.length; i++){
    accordionButton[i].addEventListener('click', () => {
      accordionBox[i].classList.toggle('idx-Contents_Others_Accordion_Box-Hidden');
      accordionButtonIcon[i].classList.toggle('idx-Contents_Others_Accordion_Button_Icon-Hidden');
      // let accordionStatus = accordionBox[i].dataset.status;
      // if(accordionStatus === 'visible'){
      //   accordionBox[i].dataset.status        = 'hidden';
      //   accordionButtonIcon[i].dataset.status = 'hidden';
      // } else {
      //   accordionBox[i].dataset.status        = 'visible';
      //   accordionButtonIcon[i].dataset.status = 'visible';
      // }
    }, false);
  }



  $("a[href^=#]").on("click", function(){
    var linkSpeed = 800;
    var linkHref = $(this).attr("href");

    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition}, linkSpeed, "swing");

    return false;
  });

})();



// WEBPACK FOOTER //
// script.js